(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .controller('VendorUpdateRequestsController', VendorUpdateRequestsController);

  /* ngInject */
  function VendorUpdateRequestsController($state, $stateParams, Flash, sessionService, vendorService, vendorUpdateRequestService) {
    const vm = this;

    vm.deleteVendorUpdateRequest = deleteVendorUpdateRequest;
    vm.id = $stateParams.vendorId;
    vm.saveVendorUpdateRequest = saveVendorUpdateRequest;
    vm.saveAndSendVendorUpdateRequest = saveAndSendVendorUpdateRequest;
    vm.sendVendorUpdateRequest = sendVendorUpdateRequest;
    vm.vendor = {};
    vm.vendorUpdateRequest = {};
    vm.vendorUpdateRequests = [];

    activate();

    function activate() {
      getVendor();
      getVendorUpdateRequests();
    }

    function deleteVendorUpdateRequest(vendorUpdateRequest) {
      vendorUpdateRequestService(sessionService.getAuthToken()).destroy({ vendorId: vm.id, id: vendorUpdateRequest.id }, _ => {
        $state.reload();
        Flash.create('success', 'Vendor update request successfully deleted.');
      }, _ => {
        Flash.create('danger', 'An unexpected error occurred. Please try again later.');
      });
    }

    function getVendor() {
      vendorService(sessionService.getAuthToken()).get({ id: vm.id }, response => vm.vendor = response);
    }

    function getVendorUpdateRequests() {
      vendorUpdateRequestService(sessionService.getAuthToken()).query({ vendorId: vm.id }, response => vm.vendorUpdateRequests = response);
    }

    function saveVendorUpdateRequest() {
      vendorUpdateRequestService(sessionService.getAuthToken()).create({ vendorId: vm.id }, vm.vendorUpdateRequest, _ => {
        $state.reload();
        Flash.create('success', 'Vendor update request successfully created.');
      }, _ => {
        Flash.create('danger', 'An unexpected error occurred. Please try again later.');
      });
    }

    function saveAndSendVendorUpdateRequest() {
      vm.vendorUpdateRequest.commit = 'send';
      vendorUpdateRequestService(sessionService.getAuthToken()).create({ vendorId: vm.id }, vm.vendorUpdateRequest, _ => {
        $state.reload();
        Flash.create('success', `Vendor update request successfully sent to ${vm.vendor.name}.`);
      }, _ => {
        Flash.create('danger', 'An unexpected error occurred. Please try again later.');
      });
    }

    function sendVendorUpdateRequest(vendorUpdateRequest) {
      vendorUpdateRequestService(sessionService.getAuthToken()).send_request({ vendorId: vm.id, id: vendorUpdateRequest.id }, _ => {
        $state.reload();
        Flash.create('success', `Vendor update request successfully sent to ${vm.vendor.name}.`);
      }, _ => {
        Flash.create('danger', 'An unexpected error occurred. Please try again later.');
      });
    }
  }
})();
